<template>
    <div>
        <app-header>
            <template slot="title">
                Meine Trends
            </template>
        </app-header>
        <div class="container">
            <div class="tags">
                <big-modal id="release" :show="showBigModalRelease" @close="showBigModalRelease = false"
                           class="big-modal">
                    <template slot="body">
                        <div class="table-wrapper-scroll-y">
                            <app-list-release></app-list-release>
                        </div>
                    </template>
                    <template slot="footer">
                        <div class="btn-base btn-modal-footer font-normal">
                            Releases auswählen
                        </div>
                    </template>
                </big-modal>
                <li class="btn font-btn-small btn-normal" @click="showBigModalRelease= true">Alle Releases</li>
                <big-modal :show="showBigModalCalendar" @close="showBigModalCalendar = false" class="big-modal">
                    <template slot="body">
                        <date-pick v-model="date" :hasInputElement="false"></date-pick>
                    </template>
                    <template slot="footer">
                        <div class="btn-base btn-modal-footer font-normal">
                            Zeitraum auswählen
                        </div>
                    </template>
                </big-modal>
                <li class="btn font-btn-small btn-normal"
                        :class="{active: defaultActive}"
                        @click="showBigModalCalendar = true"
                >letzte 30 Tage
                </li>
                <app-filter :show="showFilter" @close="showFilter = false" class="filter"></app-filter>
                <!--@click="defaultActive = false"-->
                <li class="btn font-btn-small btn-normal" @click="showFilter = true">Filter</li>
                <modal :show="showModalFeedback" @close="changeModalFeedback(false)" class="small-modal">
                    <template slot="image">
                        <img src="./../assets/images/feedback.png">
                    </template>
                    <template slot="title">Danke für dein Feedback!</template>
                    <template slot="desc">Die Beteiligung wurde abgelehnt und Bligg hat deine Begründung erhalten.
                    </template>
                    <template slot="button">
                        <div class="btn-base btn-modal-footer font-size-btn" @click="changeModalFeedback(false)">Schliessen
                        </div>
                    </template>
                </modal>
                <modal :show="showModalWilkommen" @close="changeModalWilkommen(false)" class="small-modal">
                    <template slot="image">
                        <img src="./../assets/images/wilkommen.png">
                    </template>
                    <template slot="title">Wilkommen, Max</template>
                    <template slot="desc">Dein Account wurde erfolgreich erstellt. Wir freuen uns dich bei iGroove
                        begrüssen zu dürfen!
                    </template>
                    <template slot="button">
                        <div class=" btn-base btn-modal-footer font-size-btn" @click="showModalWilkommen = false">Schliessen
                        </div>
                    </template>
                </modal>
            </div>
            <div id="focus">
                <div id="chart-desc">
                    <div class="col-6 font-title-normal">Einnahmen</div>
                    <div class="col-6 font-title-normal">CHF 1295.30</div>
                    <div class="col-6 font-produkte">Total</div>
                    <div class="col-6 font-produkte">+ CHF 195.40</div>
                </div>
                <div id="chart">
                    <highcharts :options="chartOptions"></highcharts>
                </div>
            </div>
            <div class="list table-wrapper-scroll-y">
                <app-list-trends></app-list-trends>
            </div>
        </div>
        <div id="nav">
            <app-nav></app-nav>
        </div>
    </div>
</template>

<script>
  import Header from './../components/Header'
  import Nav from './../components/Nav'
  import ListTrends from '../components/trends/ListTrends'
  import Filter from '../modals/Filter'
  import Modal from './../modals/Modal'
  import BigModal from './../modals/BigModal'
  import ListRelease from '../components/trends/ListRelease'
  import { Chart } from 'highcharts-vue'
  import modals from '../data/modals'
  import DatePick from 'vue-date-pick'
  import 'vue-date-pick/dist/vueDatePick.css'

  export default {
    name: 'Trends',
    data () {
      return {
        defaultActive: true,
        showFilter: false,
        showModalFeedback: modals.feedback,
        showModalWilkommen: modals.wilkommen,
        showBigModalRelease: false,
        showBigModalCalendar: false,
        date: '2019-01-01',
        chartOptions: {
          chart: {
            height: 163,
            width: 335,
            spacing: [0, 0, 0, 0],
            type: 'area'
          },
          title: {
            text: ''
          },
          subtitle: {
            text: ''
          },
          xAxis: {
            visible: false,
            allowDecimals: false,
            title: {
              text: ''
            },
            maxPadding: 0,
            minPadding: 0
          },
          yAxis: {
            visible: false,
            title: {
              text: ''
            }
          },
          credits: {
            enabled: false
          },
          legend: {
            enabled: false
          },
          exporting: {
            enabled: false
        },
          tooltip: {
            enabled: false
          },
          plotOptions: {
            series: {
              color: '#8c76b7',
              fillColor: '#f8f7fa',
              marker: {
                enabled: false
              },
            }
          },
          series: [{
            name: '',
            data: [
              40, 38, 35, 30, 37, 42, 40, 41, 40, 38, 48, 50, 52, 60, 55, 58, 59, 55, 51.55, 58, 54, 57, 60, 62, 68, 70, 67, 80, 85, 90, 98, 85, 70, 50, 55, 58, 60, 56, 60, 62, 67, 70
            ]
          }]
        }
      }
    },
    methods: {
      changeModalFeedback (val) {
        modals.feedback = val
        this.showModalFeedback = modals.feedback
      },
      changeModalWilkommen (val) {
        modals.wilkommen = val
        this.showModalWilkommen = modals.wilkommen
      }
    },
    components: {
      appHeader: Header,
      appNav: Nav,
      appListTrends: ListTrends,
      appFilter: Filter,
      modal: Modal,
      bigModal: BigModal,
      appListRelease: ListRelease,
      highcharts: Chart,
      DatePick
    }
  }
</script>

<style lang="scss" scoped>
    @import "../styles/app";

    .container {
        padding: 14px 18px;
        .tags {
            padding-bottom: 12px;
            & > div {
                display: inline-block;
            }
        }
        #focus {
            height: 180px;
            width: 335px;
            margin: 10px auto;
            background-color: #fff;
            border-radius: 5px;
            box-shadow: 0 2px 10px 3px rgba(0, 0, 0, 0.2);
            position: relative;
            #chart {
                position: absolute;
                bottom: 0;
                z-index: 1;
            }
            #chart-desc {
                position: absolute;
                z-index: 2;
                width: 100%;
                padding: 15px;
                div {
                    display: inline-block;
                }
                div:nth-of-type(1), div:nth-of-type(2) {
                    font-weight: normal;
                }
                div:nth-of-type(3) {
                    color: $font-grey !important;
                }
                div:nth-of-type(4) {
                    color: $font-green;
                }
                div:nth-of-type(2), div:nth-of-type(4) {
                    text-align: right;
                }
            }

        }
        .list {
            margin-top: 20px;
        }
    }

</style>
